export default __webpack_public_path__ + "static/media/admins.036b95fe.svg";